/* !
 * prodDetail.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const thisprodID = FUNCTIONS.va.isEnglish ? location.pathname.split('/')[4].replace(/\.html/, '') : location.pathname.split('/')[3].replace(/\.html/, '');

	// 最近見た製品登録
	const addRecentItemStorage = () => {
		let viewDatetime = new Date();
		viewDatetime = `${viewDatetime.getFullYear()}/${('0' + (viewDatetime.getMonth() + 1)).slice(-2)}/${(('0' + (viewDatetime.getDate())).slice(-2))} ` +
			`${('0' + (viewDatetime.getHours())).slice(-2)}:${('0' + (viewDatetime.getMinutes())).slice(-2)}:${('0' + (viewDatetime.getSeconds())).slice(-2)}`;
		localStorage.setItem(`dksRecentProdList${FUNCTIONS.va.isEnglish ? 'EN':''}-` + thisprodID, viewDatetime);
	};

	// 関連トピックスの消込／カテゴリ・タブの描画
	const relatedTopics = () => {
		let jsonURL = `/ajax${FUNCTIONS.va.isEnglish ? '/english' : ''}/topics/detail/related/list.json`;
		let params = new URLSearchParams();
		document.querySelectorAll('.topics-list-item').forEach(ele => {
			params.append('p_product', ele.getAttribute('data-key'));
		});
		console.log(`${jsonURL}?${params}`);

		fetch(`${jsonURL}?${params}`).then(response => response.json()).then(data => {
			if (data.rt_bn_news_info.length) {
				let newsInfo = data.rt_bn_news_info;

				document.querySelectorAll('.topics-list-item').forEach(ele => {
					let thisItem = newsInfo.filter(item => item._key === ele.getAttribute('data-key'))[0];

					ele.querySelector('.__category').textContent = thisItem.cf_n_category.rt_cf_n_category_name.content;

					if (thisItem.cf_n_tags.length !== 0) {
						let tagsHTML = '';
						thisItem.cf_n_tags.forEach(tag => {
							tagsHTML += `<li><span>${tag.rt_cf_nt_name_hush.content}</span></li>`;
						});
						ele.querySelector('.news-tags').innerHTML = tagsHTML;
					} else {
						ele.querySelector('.news-tags').remove();
					}
				});

				const swiper = new Swiper('.topics-slider.swiper', {
					loop: false,
					loopAdditionalSlides: 1,
					effect: 'slide',
					speed: 500,
					autoplay: false,
					slidesPerView: 'auto',
					spaceBetween: 32,
					navigation: false,
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
					watchSlidesProgress: true,
					breakpoints: {
						768: {
							slidesPerView: 3,
							spaceBetween: 16,
						},
						1025: {
							slidesPerView: 3,
							spaceBetween: 40,
							pagination: false,
						}
					}
				});
				FUNCTIONS.matchHeight(document.querySelectorAll('.topics-slider.swiper a'));
			}
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const prodDetailFUNCTIONS = () => {
		addRecentItemStorage();
		relatedTopics();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { prodDetailFUNCTIONS(); }) : prodDetailFUNCTIONS();

})(window.FUNCTIONS);
